{
    "mulakatdegerlendirme": {
        "Baslik": "Mülakat Değerlendirme",
        "AdSoyad": "Ad Soyad",
        "Telefon": "Telefon",
        "Email": "E-mail",
        "Gorusme": "Görüşme",
        "Not": "Not",
        "KisiBilgisi": "Kişi Bilgisi",
        "Iletisim": "İletişim",
        "Muhakeme": "Muhakeme",
        "CalismaAliskanliklari": "Çalışma Alışkanlıkları",
        "Degerlendirme": "Değerlendirme",
        "DegerlendirmeSonucu": "Değerlendirme Sonucu",
        "GenelDegerlendirme": "Genel Değerlendirme ve Görüşler",
        "Soru": "Soru",
        "Yanit": "Yanıt",
        "Puan": "Puan",
        "IfadeEtme": "Kendini İfade Etme",
        "SoruSormaDinleme": "Etkin Soru Sorma ve Dinleme",
        "Etkileme": "Etkileme",
        "NegatifGostergeler": "Negatif Göstergeler",
        "PozitifGostergeler": "Pozitif Göstergeler",
        "AdayKayıtEt": "Adayı Kayıt Et",
        "Gorusme1": "1. Görüşme",
        "Gorusme2": "2. Görüşme",
        "IletisimAciklama": "DEĞERLENDİRİLEN YETKİNLİK : Kişiler arası iletişim (İfade, etkin dinleme, etkin soru sorma, özetleme)",
        "MuhakemeAciklama": "DEĞERLENDİRİLEN YETKİNLİK : Muhakeme (Analiz ve karar verme)",
        "CalismaAciklama": "ÇALIŞMA ALIŞKANLIKLARI (sorumluluklarının bilincinde olma, zamanında iş sonuçlandırma)",
        "SoruKai1": "Karşınızdakilerin fikrini değiştirip kendi fikriniz doğrultusunda başarıyla yönlendirebildiğiniz bir deneyiminizi anlatınız.",
        "SoruKai2": "Karşınızdaki kişiyi iyi bir şekilde dinleyebilmek için ne gibi yöntemlere başvurduğunuzu bir örnek üzerinden anlatınız.",
        "SoruMuka1": "Sizi oldukça zorlayan bir problemi nasıl çözmeye çalıştığınızı anlatınız.",
        "SoruMuka2": "Çevrenizdeki kişilerin görüş ve ihtiyaçlarını doğru şekilde tespit ettiğiniz bir deneyiminizi anlatınız.",
        "SoruCal1": "Size verilen işi sahiplenmeniz sonucunda başarıyla tamamladığınız bir deneyiminizi anlatınız.",
        "SoruCal2": "Yapacaklarınızı yetiştiremeyecek durumda kaldığınız bir olaydan bahsediniz.",
        "YanitPlaceholder": "Yanıtınız",
        "PuanAraligi": "Puan (1-10)",
        "NegatifIndicator1": "İlettiği mesajların açık ve anlaşılır olmaması",
        "NegatifIndicator1_2": "Gereksiz ve uzun konuşmalar yaparak dinleyenleri sıkma",
        "PositiveIndicator1": "Düşüncelerini açık ve düzgün bir şekilde ifade etme",
        "PositiveIndicator1_2": "Uygun vücut dili ve ses tonu kullanımı",
        "NegatifIndicator2": "Dinlememesi nedeniyle konunun odağının dışına çıkma",
        "NegatifIndicator2_2": "Kendi söyleyeceğine odaklanarak dinlememe",
        "PositiveIndicator2": "Karşısındakini dinleme, düşüncelerini dikkate alma",
        "PositiveIndicator2_2": "Onaylama, baş sallama gibi etkin dinleme gösterme",
        "NegatifIndicator3": "Zıt fikirler sunulduğunda alternatif bulamama",
        "NegatifIndicator3_2": "Karşıt fikirlerle karşılaştığında geri çekilme",
        "PositiveIndicator3": "Ilımlı ve uzlaşmacı olma, olaylara pozitif yaklaşma",
        "PositiveIndicator3_2": "Önemli nedenlerle savunu yapabilme, sebatlı olma",
        "NegatifIndicatorMuka": "Olaylar arası ilişkileri görememe",
        "NegatifIndicatorMuka2": "Duygusal yönü ağır basan rasyonellikten uzak kararlar alma",
        "PositiveIndicatorMuka": "Neden-sonuç ilişkileri kurma",
        "PositiveIndicatorMuka2": "Mantığa ve gerçeklere dayalı yargılara ulaşma",
        "NegatifIndicatorCal": "Özveriden kaçınma, işi sahiplenmeme",
        "NegatifIndicatorCal2": "Hataları başkasının üstüne atma",
        "PositiveIndicatorCal": "Çalışma isteği ve azmine sahip olma",
        "PositiveIndicatorCal2": "Kendini işin sahibi olarak görme, eksiksiz tamamlama"
    },
    "Onceki": "Önceki",
    "Sonraki": "Sonraki",
    "Kaydet": "Kaydet",
    "Guncelle": "Güncelle",
    "Seciniz": "Seçiniz",
    "Olumlu": "Olumlu",
    "Olumsuz": "Olumsuz",
    "Arama": "Arama",
    "Kapat": "Kapat",
    "Temizle": "Temizle",
    "Yenile": "Yenile",
    "YeniEkle": "Yeni Ekle"
}
